import { Button as ButtonMui, styled } from '@mui/material';

export const Button = styled(ButtonMui)(() => ({ padding: '6px 8px' }));
